import { RenewLicenseService } from '../../../RenewLicenseService';
import { createRequestBuilder, HttpRequest, HttpHeaders } from '@quickplay/foundation';
import { PlatformAuthorizer, AuthorizationUtil } from '@quickplay/platform-authorizer';
import { RenewLicenseRequest } from '../model/RenewLicenseRequest';
import { RenewLicenseResponse } from '../model/RenewLicenseResponse';

export function createRenewLicenseServiceImpl(
  renewLicenseEndPointUrl: string,
  platform: PlatformAuthorizer,
): RenewLicenseService {
  const renewLicenseService: RenewLicenseService = {
    renewLicense(request: RenewLicenseRequest, headers?: HttpHeaders): Promise<string> {
      return renewLicenseUrl(request, headers);
    },
  };

  async function renewLicenseUrl(renewLicenseRequestData: RenewLicenseRequest, headers?: HttpHeaders): Promise<string> {
    try {
      const request = buildRenewLicenseRequest(renewLicenseRequestData, headers);
      const result = await AuthorizationUtil.makeAuthorizedRequest<any, RenewLicenseResponse>(request, platform);
      return result.data && result.data.licenseUrl;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  function buildRenewLicenseRequest(
    renewLicenseRequestData: RenewLicenseRequest,
    headers?: HttpHeaders,
  ): HttpRequest<RenewLicenseRequest> {
    return createRequestBuilder<RenewLicenseRequest>()
      .url(renewLicenseEndPointUrl)
      .headers(Object.assign({}, headers))
      .path('/media/license/refresh')
      .post(renewLicenseRequestData)
      .build();
  }

  return renewLicenseService;
}
